import CalendarLinkDataSchema from '@lts-web/schemas/CalendarLinkDataSchema';
import { readOnlyProperty } from '@lts-web/utils/ObjectUtil';

class CalendarLinkData {
    constructor (data) {
        this._data = CalendarLinkDataSchema(data);

        readOnlyProperty(this, '_data');
        readOnlyProperty(this._data, 'date');
        readOnlyProperty(this._data, 'priority');
        readOnlyProperty(this._data, 'availability');
    }

    getDate () {
        return this._data.date;
    }

    getPriority () {
        return this._data.priority;
    }

    getAvailability () {
        return this._data.availability;
    }
}

export default CalendarLinkData;